import { UserContext } from 'app/core/store/session/user-context/user-context.interface';

export const initialUserContext: UserContext = {
  contextLoaded: false,
  contextLoading: false,
  contextFailed: false,
  customersLoaded: false,
  customersLoading: false,
  id: null,
  email: null,
  firstName: '',
  lastName: '',
  initials: '',
  language: 'en',
  isAdmin: false,
  isAgent: false,
  isEpsUser: false,
  customers: null,
  salesOrganisations: null,
  canRelocate: false,
  canSelectDepot: false,
  canUseHiddenMaterials: false,
  useEmailActors: false,
  canAccessHomeMarketBonus: false,
  isSuperUser: false,
  adminRoles: {
    updateEpsUser: false,
    inviteEpsUser: false,
    createClientUser: false,
    updateClientUser: false,
    inviteClientUser: false,
    resetPassword: false,
    reInvite: false,
  },
};
